// extracted by mini-css-extract-plugin
module.exports = {"thumbnailCard":"Postings_thumbnailCard__1vxK_","previewCard":"Postings_previewCard__2UOP3"};